import { useQuery } from "@tanstack/react-query";
import { getNewHomeProgress } from "../lib/api";

const usd = (n) => `$${Math.round(n || 0).toLocaleString()}`;

export const NewHomeProgress = ({ dark = true, compact = false }) => {
  const { data } = useQuery({ queryKey: ["new-home-progress"], queryFn: getNewHomeProgress, refetchInterval: 60000 });
  const raised = data?.raised ?? 0;
  const goal = data?.goal ?? 16500;
  const pct = data?.percent ?? 0;

  return (
    <div data-testid="new-home-progress">
      <div className={`flex items-end justify-between gap-4 ${compact ? "text-sm" : ""}`}>
        <p>
          <span className="font-display text-2xl md:text-3xl font-bold text-[#F5B90A]" data-testid="new-home-raised">{usd(raised)}</span>
          <span className={dark ? "text-white/70" : "text-black/60"}> raised of {usd(goal)}</span>
        </p>
        <p className={`text-sm font-semibold ${dark ? "text-white/80" : "text-black/70"}`} data-testid="new-home-percent">{pct}%</p>
      </div>
      <div className={`mt-3 h-3 w-full rounded-full overflow-hidden ${dark ? "bg-white/15" : "bg-black/10"}`}>
        <div className="h-full rounded-full bg-gradient-to-r from-[#F5B90A] to-[#FFD75E] transition-[width] duration-1000 ease-out" style={{ width: `${Math.max(pct, 1.5)}%` }} data-testid="new-home-progress-bar" />
      </div>
      {!compact && (
        <p className={`mt-2 text-xs ${dark ? "text-white/60" : "text-black/55"}`} data-testid="new-home-sponsors">
          {data?.sponsors ?? 0} sponsor{data?.sponsors === 1 ? "" : "s"} so far · goal is the full first year of rent
        </p>
      )}
    </div>
  );
};
